import { Slider, styled } from "@mui/material";

import { Select } from "@/Components/v2/atoms/Select";

export const StyledSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.toggleButton.background,
  height: 6,
  "& .MuiSlider-rail": {
    backgroundColor: theme.palette.slider.pathColor,
    height: 14,
  },
  "& .MuiSlider-track": {
    border: "none",
    backgroundColor: theme.palette.toggleButton.background,
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: theme.palette.toggleButton.background,
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
  },
  "& .MuiSlider-mark": {
    backgroundColor: theme.palette.grey[400],
    height: 8,
    width: 2,
    "&.MuiSlider-markActive": {
      backgroundColor: theme.palette.toggleButton.background,
    },
  },
  "& .MuiSlider-markLabel": {
    fontSize: "12px",
    color: theme.palette.toggleButton.background,
    whiteSpace: "pre-line",
    textAlign: "center",
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiSelect-select": {
    padding: "8px 12px",
    fontSize: "14px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.grey[300],
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
}));
